module.exports = __webpack_public_path__ + "img/fiemslogo.47ca9a81.png";